/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { TreeSelect } from 'antd';
import localStorage from '../../../../../utils/localStorage';

const HierarchyDropdownSelection = (props) => {
  const [optionList, setOptionList] = useState([]);
  const [checkedArray, setCheckedArray] = useState(props.checkedValue || []);

  useEffect(() => {
    getOptionList(props.headerJSON);
    setCheckedArray(checkedArray);
  }, [props.headerJSON]);


  const transformKeys = (arr) => {
    return arr.map((item) => {
      const newItem = {
        title: item.Name,
        value: item.Code,
        // disabled: item.Type !== 'Device',
        ...item // Spread the rest of the properties
      };

      // Remove the old keys
      delete newItem.Name;
      delete newItem.Code;

      // If there are children, recursively transform them
      if (item.children) {
        newItem.children = transformKeys(item.children);
      }

      return newItem;
    });
  };

  const getOptionList = async (headerJSON) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let objectHeader = {};

    if (
      headerJSON &&
      headerJSON.apiPayload &&
      headerJSON.apiPayload.url &&
      headerJSON.apiPayload.method === 'GET'
    ) {
      let { url, GETParams } = headerJSON && headerJSON.apiPayload;
      objectHeader = {
        method: 'GET',
        url: `${url}?SiteId=${siteId}${GETParams ? `&${GETParams}` : ''}`,
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      };
    } else if (
      headerJSON &&
      headerJSON.apiPayload &&
      headerJSON.apiPayload.url &&
      headerJSON.apiPayload.method &&
      headerJSON.apiPayload.payload &&
      headerJSON.apiPayload.method === 'POST'
    ) {
      objectHeader = {
        method:headerJSON && headerJSON.apiPayload && headerJSON.apiPayload.method? headerJSON.apiPayload.method:'',
        url: `${headerJSON.apiPayload.url}?SiteId=${siteId}`,
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        data:headerJSON && headerJSON.apiPayload && headerJSON.apiPayload.payload  ? headerJSON.apiPayload.payload :{},
      };
    }

    try {
      const response = await axios(objectHeader);
      if (Array.isArray(response.data)) {
        let transformedOptionList = transformKeys(response.data);
        setOptionList(transformedOptionList);
      }
    } catch (error) {
      return [];
    }
  };

  const handleChange = (selectedValue, selectedObject) => {
    props.handleDropdownChange([selectedValue], selectedObject);
  };

  return (
    <TreeSelect
      style={{ width: 300 }}
      showSearch
      value={props.checkedArray[0]}
      placeholder="Select"
      allowClear
      treeDefaultExpandAll
      onSelect={handleChange}
      treeData={optionList}
    />
  );
};

export default HierarchyDropdownSelection;
